const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
  postalCodeInput: '[name="address[zip]"]',
  phoneInput: '[name="address[phone]"]',
  addressForm: '[id^="address_form_"]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
        container,
        addressContainer: container.querySelector(selectors.addressContainer),
        toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
        cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
        deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
        countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        addressForms: container.querySelectorAll(selectors.addressForm),
      }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        if (select.id === 'AddressCountryNew') return;
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });

    this.elements.addressForms.forEach((form) => {
      form.addEventListener('submit', this._handleFormValidation);

      const postalCodeInput = form.querySelector(selectors.postalCodeInput);
      const phoneInput = form.querySelector(selectors.phoneInput);

      if (postalCodeInput) {
        postalCodeInput.addEventListener('change', () => this._removeValidationError(postalCodeInput));
      }
      if (phoneInput) {
        phoneInput.addEventListener('change', () => this._removeValidationError(phoneInput));
      }
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };

  _handleFormValidation = (event) => {
    const form = event.target;
    const country = form.querySelector(selectors.addressCountrySelect).value;
    const postalCodeInput = form.querySelector(selectors.postalCodeInput);
    const phoneInput = form.querySelector(selectors.phoneInput);

    const errors = [];
    const validationRules = {
      "United Kingdom": {
        postalCode: /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i,
        phone: /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/,
      }
    };

    if (validationRules[country]) {
      const { postalCode: postalCodeRegex, phone: phoneRegex } = validationRules[country];

      if (postalCodeRegex && !postalCodeRegex.test(postalCodeInput.value.trim())) {
        this._showValidationError(postalCodeInput, 'Enter a valid ZIP / postal code for United Kingdom');
      } else {
        this._removeValidationError(postalCodeInput);
      }

      if (phoneRegex && !phoneRegex.test(phoneInput.value.trim())) {
        this._showValidationError(phoneInput, 'Enter a valid phone number');
      } else {
        this._removeValidationError(phoneInput);
      }
    }

    const invalidFields = form.querySelectorAll('.is-invalid');
    if (invalidFields.length > 0) {
      event.preventDefault();
    }
  };

  _showValidationError(input, message) {
    input.classList.add('is-invalid');
    const closestField = input.closest(".field");
    let errorMessage;
    if (closestField) {
      errorMessage = closestField.querySelector(".invalid-feedback");
    }

    if (!errorMessage) {
      errorMessage = document.createElement('div');
      errorMessage.className = 'invalid-feedback';
      input.parentNode.appendChild(errorMessage);
    }

    errorMessage.textContent = message;
  }

  _removeValidationError(input) {
    input.classList.remove('is-invalid');
    const closestField = input.closest(".field");
    if (closestField) {
      const errorMessage = closestField.querySelector(".invalid-feedback");
      if (errorMessage) {
        errorMessage.remove();
      }
    }
  }
}
